var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reference-layout" },
    [
      _vm._t("default"),
      _c(
        "div",
        { staticClass: "layout" },
        [
          _vm._t("header"),
          _c(
            "div",
            [
              _c("div", { staticClass: "subheader" }, [_vm._t("subheader")], 2),
              _vm._t("filters"),
              _vm._t("list"),
            ],
            2
          ),
        ],
        2
      ),
      _c("to-top-button", { attrs: { element: ".layout" } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }